import { Directive, Inject, Input, NgModuleRef, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { InfoModal } from '../../../../modals/info/info.modal';
import { MODAL_TOOLTIP, MODAL_TOOLTIP_KEY_ENUM } from '../hints';

@Directive()
export abstract class FormWithHintAbstract implements ControlValueAccessor, OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() hintModal: boolean;
  @Input() disabled: boolean;
  @Input() tooltipHint: MODAL_TOOLTIP_KEY_ENUM;
  private subscribers: any = {};

  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, private moduleRef: NgModuleRef<any>) {}

  ngOnInit() {
    this.subscribers.innerControl = this.innerControl.valueChanges.subscribe((value: any) => {
      this.onChange(value);
    });
  }

  public openTooltipModal(): void {
    this.modalsService.open(
      InfoModal,
      {
        data: {
          title: this.label,
          subTitle: $localize`:@@common.info:Info`,
          body: MODAL_TOOLTIP[this.tooltipHint],
          footerType: null,
          hasCopy: false,
          class: '-info',
        },
      },
      this.moduleRef
    );
  }

  public innerControl = new FormControl();

  protected onChange: (value: any) => void = () => {};
  protected onTouched: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.innerControl.patchValue(obj);
    if (this.control && this.control.value !== obj) {
      this.control.patchValue(obj);
    } else {
      this.onChange(obj);
      this.onTouched();
    }
  }
}
